<!-- eslint-disable vue/no-v-html -->
<template>
  <Teleport to="body">
    <div class="cookie-banner" :class="{ active: cookiesBannerActive }">
      <div class="cookie-title">Používáme Cookies</div>
      <div class="cookie-main-text">
        <p>
          Pro správné fungování těchto webových stránek používáme technické cookies. Vedle těchto
          cookies mohou webové stránky ukládat též analytické cookies pro účely statistik. Kliknutím
          na „Povolit vše“ vyjadřujete souhlas s použitím všech cookies. Můžete však kliknout na
          „Povolit vybrané“ a poskytnout souhlas s Vámi vybranými cookies nebo na „Odmítnout“ a
          poskytnout tak souhlas pouze s nezbytnými technickými cookies. Podrobnější informace
          najdete v Prohlášení o používání cookies.
        </p>
      </div>
      <div class="cookie-btns">
        <button
          color="neutral"
          variant="outline"
          size="lg"
          class="cursor-pointer rounded-full"
          @click="showSettings"
        >
          Nastavení Cookies
        </button>
        <button
          color="neutral"
          variant="outline"
          size="lg"
          class="cursor-pointer rounded-full"
          @click="allowNecessaryPermissions"
        >
          Povolit jenom nezbytné
        </button>
        <button class="dark:text-default cursor-pointer rounded-full" @click="allowAll">
          Povolit všechny
        </button>
      </div>
    </div>
  </Teleport>
  <Teleport to="body">
    <div class="cookie-modal" :class="{ active: cookiesSettingsModalActive }">
      <div class="cookie-modal-div">
        <div class="cookie-title">Nastavení Cookies</div>
        <div class="cookie-main-text">
          <p>
            Bez některých cookies to nejde. Pomozte nám zlepšovat naše služby tím, že nám udělíte
            souhlas s využitím všech cookies.
          </p>
        </div>

        <div v-for="(item, id) in cookiePermissions" :key="id" class="cookie-settings-item">
          <div class="cookie-settings-item-div">
            <input
              type="checkbox"
              :disabled="id === 'technical'"
              :checked="item"
              @change="handleCheckboxChange($event, id)"
            />
            <span>
              {{ coookieTexts[id].title }}
            </span>
          </div>
          <p v-html="coookieTexts[id].text" />
        </div>

        <div class="cookie-btns">
          <button
            color="neutral"
            variant="outline"
            size="lg"
            class="cursor-pointer rounded-full"
            @click="allowChosenPermissions"
          >
            Uložit nastavení
          </button>
          <button
            color="neutral"
            variant="outline"
            size="lg"
            class="cursor-pointer rounded-full"
            @click="allowNecessaryPermissions"
          >
            Povolit jenom nezbytné
          </button>
          <button class="dark:text-default cursor-pointer rounded-full sm:block" @click="allowAll">
            Povolit všechny
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { initGoogleAnalytics } from '@/utils/googleAnalytics'
import { getCookie, setCookie } from '@/utils/cookies'

const coookieTexts = {
  technical: {
    title: 'Základní cookies',
    text: 'Cookies nezbytné pro zajištění chodu stránek.',
  },
  analytical: {
    title: 'Analýza a statistika',
    text: 'Tyto cookies pomáhají statisticky vyhodnotit používání webových stránek.',
  },
}

const cookiePermissions = ref({
  technical: false,
  analytical: false,
})
const cookiesBannerActive = ref(false)
const cookiesSettingsModalActive = ref(false)

onMounted(() => {
  activateBanner()
})

type CookiesType = 'technical' | 'analytical'

function activateBanner() {
  Object.keys(cookiePermissions.value).forEach((key) => {
    const cookie = getCookie(key)
    if (cookie === 'true') {
      cookiePermissions.value[key as CookiesType] = true
    }
    if (key === 'analytical') {
      if (cookie === 'true') {
        initGoogleAnalytics()
      }
    }
  })

  if (Object.values(cookiePermissions.value).some((el) => el === false)) {
    setTimeout(() => {
      cookiesBannerActive.value = true
    }, 500)
  }
}

function showSettings() {
  cookiePermissions.value['technical'] = true
  cookiesBannerActive.value = false
  cookiesSettingsModalActive.value = true
}

function allowAll() {
  Object.keys(cookiePermissions.value).forEach((key) => {
    cookiePermissions.value[key as CookiesType] = true
    setCookie(key, true)
  })
  initGoogleAnalytics()
  cookiesBannerActive.value = false
  cookiesSettingsModalActive.value = false
}

function allowNecessaryPermissions() {
  Object.keys(cookiePermissions.value).forEach((key) => {
    if (key === 'technical') {
      cookiePermissions.value[key as CookiesType] = true
      setCookie(key, true)
    } else {
      cookiePermissions.value[key as CookiesType] = false
      setCookie(key, false)
    }
  })
  //rejectAll()
  cookiesBannerActive.value = false
  cookiesSettingsModalActive.value = false
}

function allowChosenPermissions() {
  if (cookiePermissions.value['analytical']) {
    initGoogleAnalytics()
  }
  Object.keys(cookiePermissions.value).forEach((key) => {
    setCookie(key, cookiePermissions.value[key as CookiesType])
  })
  cookiesBannerActive.value = false
  cookiesSettingsModalActive.value = false
}

function handleCheckboxChange(e: Event, id: CookiesType) {
  const el = e.target as HTMLInputElement
  cookiePermissions.value[id] = el.checked
}

/* function checkCookie (name: string, defaultValue?: string) {
    const cookieExists = document.cookie.indexOf(name) > -1 ? true : false
    if (cookieExists) {
        return getCookie(name)
    }
    return defaultValue
} */
</script>

<style>
.cookie-banner {
  --color-primary: #fbbf24;
  position: fixed;
  right: 50%;
  bottom: 5rem;
  z-index: 999999999;
  height: max-content;
  max-height: 50%;
  width: calc(100% - 40px);
  transform: translateX(50%) translateY(calc(100% + 2rem));
  border: 1px solid var(--color-border-default);
  padding: 1rem;
  background-color: #fff;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 300;
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
  transition-duration: 150ms;
  transition-timing-function: ease-in;
  overflow-y: auto;
  visibility: hidden;
  opacity: 0;
}

.cookie-banner.active {
  visibility: visible;
  transform: translateX(50%) translateY(0);
  opacity: 1;
  transition-timing-function: ease-out;
}

@media (min-width: 640px) {
  .cookie-banner {
    right: auto;
    bottom: 1.5rem;
    left: 1.5rem;
    width: 36rem;
    transform: translateX(0) translateY(calc(100% + 6rem));
    padding: 1.75rem;
    border-radius: 0.5rem;
  }

  .cookie-banner.active {
    transform: translateX(0) translateY(0);
  }
}

@media (min-width: 1536px) {
  .cookie-banner {
    bottom: 2rem;
    left: 2rem;
  }
}

.cookie-title {
  font-size: 1.125rem;
  font-weight: 500;
}

.cookie-main-text p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.cookie-btns {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

@media (min-width: 640px) {
  .cookie-btns {
    justify-content: flex-end;
  }
}

.cookie-btns .cookie-btn {
  background-color: #fff;
  cursor: pointer;
  border-radius: 0.375rem;
  border: 1px solid;
  padding: 0.5rem;
}

.cookie-btns .cookie-btn.allow {
  background-color: var(--color-primary);
  color: var(--color-text-default);
}

.cookie-btns .cookie-btn.allow:hover {
  background-color: color-mix(in srgb, var(--color-primary) 80%, transparent);
}

.cookie-modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  z-index: 9999999999;
  background-color: rgb(0 0 0 / 0.3);
  font-weight: 300;
  opacity: 0;
  transition-duration: 200ms;
  transition-timing-function: ease-in;
}

.cookie-modal .cookie-modal-div {
  background-color: #fff;
  height: fit-content;
  max-height: 90%;
  width: calc(100% - 40px);
  max-width: 800px;
  padding: 1rem;
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
  transform: scale(0.5);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition-duration: 100ms;
  transition-timing-function: ease-in;
}

@media (min-width: 640px) {
  .cookie-modal .cookie-modal-div {
    padding: 2rem;
    font-size: 1rem;
  }
}

.cookie-modal.active {
  visibility: visible;
  opacity: 1;
  transition-timing-function: ease-out;
}

.cookie-modal.active .cookie-modal-div {
  transform: scale(1);
  transition-duration: 100ms;
  transition-timing-function: ease-out;
}

.cookie-modal .cookie-settings-item {
  margin-bottom: 1rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.cookie-modal .cookie-settings-item .cookie-settings-item-div {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.cookie-modal .cookie-settings-item .cookie-settings-item-div input {
  margin-right: 0.75rem;
}
</style>
